import Vue from 'vue'

const state = {
  inventory: null
}

const mutations = {
  SET_INVENTORY (state, inventory) {
    state.inventory = inventory
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('inventory/deprecated')
      .then(response => {
        commit('SET_INVENTORY', response.data)
      })
  }
}

const getters = {
  getAll: state => {
    return state.inventory
  },
  getInventoryItemByID: state => inventoryItemID => {
    return state.inventory[inventoryItemID]
  },
  getInventoryOf: state => inventoryItemID => {
    return Object.values(state.inventory).filter(item => {
      return item.inventory_item_id === inventoryItemID
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
